import { Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { GoToSong } from './GoToSong';

interface ReleaseErrorMsgProps {
  tab?: 'details' | 'contributions' | 'lyrics' | 'splits';
  invalid: boolean;
  children?: ReactNode;
  focus?: string;
}

export const ReleaseErrorMsg = ({
  tab = 'details',
  invalid,
  children,
  focus,
}: ReleaseErrorMsgProps) => {
  if (invalid) {
    return (
      <Flex fontSize="xxs">
        {children}&nbsp;
        <GoToSong tab={tab} focus={focus} />
      </Flex>
    );
  }

  return null;
};
